var React = require('react');

function ArrowLineInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.6581 7L14 8.40176L7.64661 15L28 15V17H7.64661L14 23.5982L12.6581 25L4 16L12.6581 7Z","fill":"#383F49"}));
}

ArrowLineInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","role":"img","aria-label":""};

module.exports = ArrowLineInline;

ArrowLineInline.default = ArrowLineInline;
